import { Boxes, PackagePlus, ClipboardCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FilterBar } from "@/components/shared/FilterBar";

// Lišta Skladu = sdílená FilterBar bez tlačítka Filtry (onFilterClick nepředáváme).
// Segmenty = taby (Zásoby / K naskladnění / Pohyby), hledání přes name/doklad,
// vpravo Ruční příjemka + Inventura (jen pro ops role) přes `trailing`.
export function WarehouseToolbar({ tab, onTab, counts, search, onSearch, canOps, onManual, onInventory }) {
  const segments = [{
    testid: "warehouse-tabs",
    value: tab, onChange: onTab,
    tabs: [
      { value: "stock", label: "Zásoby", count: counts.stock, testid: "tab-stock" },
      { value: "queue", label: "K naskladnění", count: counts.queue, testid: "tab-queue" },
      { value: "movements", label: "Pohyby", count: counts.movements, testid: "tab-movements" },
    ],
  }];
  const trailing = canOps ? (
    <div className="flex items-center gap-2">
      <Button variant="outline" className="h-11 rounded-full" onClick={onManual} data-testid="manual-receive-btn">
        <PackagePlus size={15} className="mr-1" /> Ruční příjemka
      </Button>
      <Button variant="outline" className="h-11 rounded-full" onClick={onInventory} data-testid="inventory-btn">
        <ClipboardCheck size={15} className="mr-1" /> Inventura
      </Button>
    </div>
  ) : null;

  return (
    <FilterBar testid="warehouse-toolbar" segments={segments}
      search={search} onSearch={onSearch} searchPlaceholder="Hledat materiál nebo doklad…"
      trailing={trailing} />
  );
}
